/** Utilitarios internos da camada de componentes. Nao exportados no barril publico. */

/**
 * Concatena classes ignorando `false`, `undefined` e `''`.
 *
 * Escrito aqui em vez de `clsx`: sao 4 linhas, e o orcamento da rota de entrada e por rota e
 * normativo (`PWA.md §11.2`, §10.7). Dependencia de 500 bytes tambem e dependencia de
 * atualizacao, de auditoria de supply chain e de lockfile.
 */
export function cx(...partes: readonly (string | false | null | undefined)[]): string {
  return partes.filter((parte): parte is string => typeof parte === 'string' && parte !== '').join(' ');
}

/** `useId` do React 18+ produz ids com `:`, que quebram seletor CSS. Este normaliza. */
export function idSeguro(bruto: string, sufixo: string): string {
  return `${bruto.replace(/:/g, '')}-${sufixo}`;
}
